export const REACT_APP_GQL_API = 'https://vhg.easyroom.io:8090/graphql'
export const REACT_APP_GQL_API_WS = 'wss://vhg.easyroom.io:8090/graphql'
export const REACT_APP_GOOGLE_OAUTH_API_CLIENT_ID = '557742082481-iqqsj4c8ufbrig0imqptpegid9t6h3vl.apps.googleusercontent.com'
export const REACT_APP_ACCES_KEY = 'DO00YQ6PGNJYAGWR9DQ9'
export const REACT_APP_SECRET_KEY = 'qaHTyBDhzSzskRkn8HgNueWSGRW/OeaepHjJvWJ3+lE'
export const REACT_APP_BUCKET_REGION = 'us-east-1'
export const REACT_APP_SPACES_ENDPOINT = 'nyc3.digitaloceanspaces.com'
export const REACT_APP_ARTICULOS_BUCKET = 'articulos'
export const REACT_APP_AVATARS_BUCKET_FOLDER = 'avatars'

export const REACT_APP_REST_API = 'https://faas-sfo3-7872a1dd.doserverless.co/api/v1/web/fn-d9d3f7d6-0916-480e-8cca-523be29cfcb4'
